// Vendor imports
const React = require('react')
const qs = require('qs')
// Client V2 common imports
const { trackAppDownload } = require('client-v2/common/containers/promo-badge/selectors')
// Shared imports
const { urlWithoutProtocol } = require('shared/utils')

/**
 * This is a constant so that it does not change between renders
 * @type {[]}
 * @readonly
 */

function IntoLandingDownloadButton(props) {
  const { buttonText, className, isIos, isAndroid, isDesktop, isTablet, deeplinkUrls, showSMSModal, onClick } = props

  const handleDownloadClick = React.useCallback(
    event => {
      const { provider } = event.currentTarget.dataset
      event.preventDefault()
      if (provider) {
        const deeplinkHref = deeplinkUrls[provider]
        trackAppDownload(provider)
        const deeplinkData = {
          // Delivered as query parameter when handling the universal links.
          'deeplink_url': location.href,
          // Fallbacks to mix://$deeplink_path when universal links do not work.
          // Docs: https://docs.branch.io/pages/links/integrate/#deep-linking
          '$deeplink_path': urlWithoutProtocol(location.href)
        }

        const queryString = qs.stringify(deeplinkData)
        location.assign(`${deeplinkHref}?${queryString}`)
      }
      // Workaround for iPad detection
      if (isDesktop && !isTablet) {
        if (onClick) {
          onClick()
        }
        showSMSModal({
          deeplinkData: null,
          isDownloadPromptVisible: false
        })
      }
    },
    [ deeplinkUrls, isDesktop, isTablet, showSMSModal, onClick ]
  )

  return (
    <button className={className} data-provider={isIos ? 'ios' : isAndroid ? 'android' : null} onClick={handleDownloadClick}>{buttonText}</button>
  )
}

if (__DEV__) {
  // Prop-checking imports
  const PropTypes = require('prop-types')
  IntoLandingDownloadButton.propTypes = {
    buttonText: PropTypes.string.isRequired,
    className: PropTypes.string,
    isAndroid: PropTypes.bool,
    isDesktop: PropTypes.bool.isRequired,
    isTablet: PropTypes.bool.isRequired,
    isIos: PropTypes.bool.isRequired,
    deeplinkUrls: PropTypes.object.isRequired,
    showSMSModal: PropTypes.func,
    onClick: PropTypes.func
  }
}

module.exports = IntoLandingDownloadButton
